export const AUTH_SIGN_OUT = '[AUTH] sign out';
export const AUTH_SET_USER_DATA = '[AUTH] set user data';
export const AUTH_SET_USER_SIGNED_OUT = '[AUTH] set user signed out';



// WEBPACK FOOTER //
// ./src/auth/constants/ActionTypes.ts